import React, { ReactElement } from 'react';
import { Table, TableContainer } from '@odin-labs/components';
import { paginationSizePerPage as limit } from 'utils/constants';
import { LoadingError } from 'components/loadingError';
import { useGetJobsiteContainerEquipmentTabQuery } from 'apollo/generated/client-operations';
import { usePageQueryParams } from 'utils/usePageQueryParams';
import { JobsiteTabProps } from 'containers/jobsite/types';

import { getColumns } from './tables';

export function JobsiteEquipmentTabContainer(
  props: JobsiteTabProps,
): ReactElement {
  const { jobsiteId, onTabApiChange } = props;
  const { updateUrl } = usePageQueryParams();

  const { data, loading, error, refetch } =
    useGetJobsiteContainerEquipmentTabQuery({
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      variables: {
        jobsiteId,
      },
    });

  const columns = React.useMemo(() => getColumns(), []);

  const onPageChangeHandler = (_pageSize: number, pageIndex: number): void => {
    updateUrl({
      page: pageIndex ? pageIndex + 1 : null,
    });
  };

  const jobsiteEquipmentCount = data?.getJobsiteEquipmentData?.count ?? 0;
  const pageCount = Math.ceil(jobsiteEquipmentCount / limit);

  React.useEffect(() => onTabApiChange({ refetchData: refetch }), [refetch]);

  if (error) {
    return <LoadingError error={error} />;
  }

  return (
    <TableContainer className="jobsite-equipment-container">
      <Table
        loading={loading}
        columns={columns}
        data={data?.getJobsiteEquipmentData?.results}
        initialState={{ pageSize: limit }}
        pageCount={pageCount}
        remote
        enablePagination
        onPageChange={onPageChangeHandler}
        disableGlobalFilter
      />
    </TableContainer>
  );
}
